<template>
	<div class="my_department">
		<div class="my_department-title">{{department.hospitalName}}</div>
		<div class="my_department-title mb-28">{{department.teamName}}</div>
		<base-card title="团队介绍">
			<base-ellipsis :text="department.teamProfile" />
		</base-card>
		<div class="other_doctor">
			<base-card title="团队成员">
				<template v-if="department.list.length">
					<van-row
						type="flex"
						align="center"
						class="doctor_item"
						v-for="item in department.list"
						:key="item.id"
						@click="clickShowItem(item)"
					>
						<van-col :span="8">
							<div class="avatar">
								<img :src="item.avatar" :alt="item.name" :title="item.name" />
							</div>
						</van-col>
						<van-col :span="8">
							<div class="user_name text-center">{{ item.name || '--' }}</div>
						</van-col>
						<van-col :span="8">
							<div class="title text-right">{{ item.titleName || '--' }}</div>
						</van-col>
					</van-row>
				</template>

				<van-empty v-else description="暂无团队成员">
					<template #image>
						<img class="empty_img" src="@/assets/img/empty_3.png" alt="" />
					</template>
				</van-empty>
			</base-card>
		</div>
		<van-popup v-model="show" round position="bottom" style="height: 500px;">
			<div class="popup_main">
				<div class="icon_close">
					<img src="@/assets/icon/icon_close_nobg.png" alt="" @click="show = false" />
				</div>
				<div class="popup_doctor_info">
					<div class="avatar">
						<img :src="popupDoctor.avatar" :alt="popupDoctor.name" :title="popupDoctor.name" />
					</div>
					<div class="info">
						<h2>{{ popupDoctor.name || '--' }}</h2>
						<p>{{ popupDoctor.titleName || '--' }}</p>
					</div>
				</div>
				<h2 style="margin-top:15px">简介</h2>
				<base-about :text="popupDoctor.personalProfile || '暂无医生简介'" show-all />
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
    name: 'MyDepartment',
    data: () => ({
        department: {
            list: []
        },
        show: false,
        popupDoctor: {},
        text: ''
    }),
    created () {
        this.load()
    },
    methods: {
        async load () {
            const res = await this.$api.doctor.getTeamDetail(this.$route.params.id)
            if (!res.code) {
                this.department = res.data
                this.department.list = []
            }
        },
        clickShowItem (item) {
            this.popupDoctor = item
            this.show = true
        }
    }
}
</script>

<style scoped lang="less">
.my_department {
	padding: 32px;
	&-title {
		font-size: 36px;
		color: #1f2329;
		text-align: center;
		line-height: 48px;
		font-weight: 500;
	}
	.doctor_info {
		display: flex;
		align-items: center;
		.avatar {
			flex: 0 0 162px;
			> img {
				width: 162px;
				height: 162px;
				vertical-align: middle;
				border-radius: 30px;
			}
		}
		.info {
			padding-left: 20px;
			.user_name {
				font-family: PingFangSC-Medium;
				font-size: 46px;
				font-weight: 500;
				color: #000;
				display: flex;
				align-items: center;
				> .tag {
					display: inline-block;
					width: 119px;
					height: 38px;
					margin-left: 12px;
					line-height: 38px;
					border-radius: 6px;
					border: 1px solid @primary;
					font-family: PingFangSC-Medium;
					font-size: 22px;
					font-weight: 500;
					text-align: center;
					color: @primary;
				}
			}
			p {
				height: 39px;
				font-family: PingFangSC-Regular;
				font-size: 28px;
				font-weight: normal;
				color: #1f2329;
				margin-top: 10px;
				display: flex;
				align-items: center;
				> span {
					display: inline-block;
					width: 16px;
					height: 0px;
					transform: rotate(90deg);
					border: 2px solid #eff0f1;
					margin: 0 14px;
				}
			}
		}
	}
	.other_doctor {
		padding-top: 6px;
		margin-top: 28px;
		background-color: @primary;
		border-radius: 16px;
		.doctor_item {
			& + .doctor_item {
				margin-top: 24px;
			}
			box-sizing: border-box;
			padding: 28px 40px;
			border-radius: 15px;
			border: 1px solid #dee0e3;
			.avatar {
				flex: 0 0 80px;
				> img {
					width: 80px;
					height: 80px;
					vertical-align: middle;
					border-radius: 20px;
				}
			}
			.user_name {
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: 500;
				color: #1f2329;
			}
			.title {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: @gray-9;
			}
		}
	}
	.popup_main {
		padding: 0 40px 40px;
		background-image: linear-gradient(180deg, #e9feff 0%, #fff 50%);
		.icon_close {
			padding: 34.12px 0;
			text-align: right;
			> img {
				width: 25.67px;
				height: 25.67px;
				vertical-align: middle;
			}
		}
		.popup_doctor_info {
			display: flex;
			align-items: center;
			.avatar {
				flex: 0 0 100px;
				> img {
					width: 100px;
					height: 100px;
					border-radius: 20px;
					vertical-align: middle;
				}
			}
			.info {
				flex: auto;
				padding-left: 20px;
				h2 {
					font-family: PingFangSC-Medium;
					font-size: 36px;
					font-weight: 500;
					color: #333;
				}
				p {
					margin-top: 4px;
					font-family: PingFangSC-Regular;
					font-size: 28px;
					font-weight: normal;
					color: #666;
				}
			}
		}
	}
}
.popup_title {
}
</style>

<style lang="less">
.my_department {
	.van-empty {
		padding-top: 100px;
		.van-empty__image {
			height: initial;
		}
		.van-empty__description {
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			line-height: 31px;
			color: #8f959e;
		}
	}
}
</style>
